import request from "superagent";
import { ENDPOINT } from "config";

const getApiGenerator = (route, query = {}, sessionKey) =>
  request.get(ENDPOINT + route).query(query).query({ session_key: sessionKey });

export default getApiGenerator;
